import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-cargonizer-printers',
  templateUrl: './cargonizer-printers.component.html',
  styleUrls: ['./cargonizer-printers.component.css']
})
export class CargonizerPrintersComponent implements OnInit {
    public itemsListPrinters: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadPrinters() {
        this.itemsListPrinters = await this.datatask.Post(423);
    }

    private async init() {
        this.loadPrinters();
    }

    ngOnInit() {
        this.init();
    }
}
